import { marked } from 'marked'

// 根据 inline token 的 raw 定位，不在代码、转义、链接或 HTML 内猜测边界。
export function textRanges(raw) {
  const ranges = []
  let offset = 0
  const tokens = marked.Lexer.lexInline(raw)
  if (tokens.map(token => token.raw).join('') !== raw)
    return ranges
  for (const token of tokens) {
    if (token.type === 'text')
      ranges.push([offset, offset + token.raw.length])
    offset += token.raw.length
  }
  return ranges
}

export function mapReportBlocks(tokens, transform, types = ['heading', 'paragraph']) {
  return tokens.map(token => {
    if (!types.includes(token.type))
      return token.raw
    return transform(token.raw)
  }).join('')
}

export function hasRepairedReport(appliedKeys) {
  return appliedKeys.includes('collapsed-report-headings')
}

export function repairReportParagraphs({ source, tokens, appliedKeys }) {
  if (!hasRepairedReport(appliedKeys))
    return source
  return mapReportBlocks(tokens, raw => {
    const ranges = textRanges(raw)
    let result = raw
    const gaps = []
    for (const [start, end] of ranges) {
      for (const match of raw.slice(start, end).matchAll(/[ \t]{2,}/g)) {
        const position = start + match.index
        // 表格单元格内的空白不用于分段。未成功恢复的可疑表格也保留。
        const lineStart = raw.lastIndexOf('\n', position - 1) + 1
        if (raw.slice(lineStart, position).includes('|'))
          continue
        if (position === 0 || position + match[0].length === raw.trimEnd().length)
          continue
        gaps.push([position, position + match[0].length])
      }
    }
    for (const [start, end] of gaps.reverse())
      result = `${result.slice(0, start)}\n\n${result.slice(end)}`
    return result
  })
}

export function validateReportParagraphs({ beforeTokens, afterTokens }) {
  const paragraphs = tokens => tokens.filter(token => token.type === 'paragraph').length
  return paragraphs(afterTokens) > paragraphs(beforeTokens)
}

export function repairReportLists({ source, tokens, appliedKeys }) {
  if (!hasRepairedReport(appliedKeys))
    return source
  return mapReportBlocks(tokens, raw => {
    // 明确的「- **标签**」项目，至少两项；普通负号、连字符和正文不推测为列表。
    const positions = []
    for (const [start, end] of textRanges(raw)) {
      for (const match of raw.slice(start, end).matchAll(/[ \t]+-[ \t]+(?=\*\*)/g))
        positions.push(start + match.index)
      // ** 在下一个 strong token 中，因此也检查 text token 尾部的项目标记。
      const match = /[ \t]+-[ \t]+$/.exec(raw.slice(start, end))
      if (match && raw.slice(end).startsWith('**'))
        positions.push(start + match.index)
    }
    const unique = [...new Set(positions)]
    const firstItem = /^[ \t]*-[ \t]+\*\*/.test(raw) ? 1 : 0
    if (unique.length + firstItem < 2)
      return raw
    let result = raw
    for (const position of unique.reverse())
      result = `${result.slice(0, position)}\n${result.slice(position).trimStart()}`
    return result
  }, ['heading', 'paragraph', 'list'])
}

export function validateReportLists({ beforeTokens, afterTokens }) {
  const items = tokens => tokens.filter(token => token.type === 'list')
    .reduce((sum, list) => sum + list.items.length, 0)
  return items(afterTokens) > items(beforeTokens)
}
